import React, { Component } from 'react'
import copy from 'copy-to-clipboard'
import { StatusAlertService } from 'react-status-alert'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import MessageUtils from '../../../util/MessageUtils'
import URLUtils from '../../../util/URLUtils'
import TaskDetailUI from './TaskDetailUI.js'

class TaskDetailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      editPriority: false,
      editDueDate: false,
      editAssignee: false,
      editTaskNotes: false,
      // list of values (cannot use list from task list filters because "All" is added in filters)
      statusList: null,
      priorityList: null,
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
    this.bottomDivRef = null
  }

  render() {
    console.log(this.props.task);
    return (
      <TaskDetailUI
        context={this.props.context}
        messageList={this.state.messageList}
        project={this.props.project}
        task={this.props.task}
        // title
        onCopyClick={this.onCopyClick}
        // top
        statusList={this.state.statusList}
        priorityList={this.state.priorityList}
        projectUserMap={this.props.projectUserMap}
        projectUserList={this.props.projectUserList}
        onTaskListUpdated={this.props.onTaskListUpdated}
        //
        onForceTaskListRefresh={this.props.onForceTaskListRefresh}
        onForceProjectUserListRefresh={this.props.onForceProjectUserListRefresh}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    this.getTaskStatuses(context)
    this.getTaskPriorities(context)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
    }
  }

  onCopyClick = (event) => {
    event.preventDefault()
    let link = `${URLUtils.getBaseURL()}/tasks/${this.props.task.taskNumber}`
    copy(link)
    StatusAlertService.showInfo(MessageUtils.getMessageValue(this.state.messageList, 'c_copied_link', [link]),
      {withCloseIcon: false})
  }

  getTaskStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/taskStatuses`,
      cacheKey: CacheKeys.TaskStatuses(),
      callback: this.getTaskStatusesCallback,
      ttlInSecs: 3600*24*7
    })
    cacheManager.getObject2(context)
  }

  getTaskStatusesCallback = (response) => {
    this.setState({statusList: response.list.map(item => ({value: item.key, label: item.value}))})
  }

  getTaskPriorities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/taskPriorities2`,
      cacheKey: CacheKeys.TaskPriorities2(),
      callback: this.getTaskPrioritiesCallback,
      ttlInSecs: 3600*24*7
    })
    cacheManager.getObject2(context)
  }

  getTaskPrioritiesCallback = (response) => {
    this.setState({priorityList: response.list.map(item => ({value: item.key, label: item.value}))})
  }

  getMessages(context) {
    let arr = [
      'c_copy_link',
      'c_copied_link',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('c_tsk_dtl', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default TaskDetailSF
